import { memo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { TimePicker, TimePickerProps } from '@mui/x-date-pickers/TimePicker';

type Props = TimePickerProps<Date> & {
  name: string;
  error?: boolean;
  helperText?: string;
};

function RHFTimePicker({ name, helperText, ...other }: Props) {
  const { control } = useFormContext();

  // Function to check if a time should be disabled
  const shouldDisableTime = (value: Date, view: 'hours' | 'minutes' | 'seconds') => {
    if (view === 'minutes') {
      return value.getMinutes() % 10 !== 0;
    }
    return false;
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TimePicker
          {...field}
          inputRef={field.ref}
          minutesStep={10}
          skipDisabled
          shouldDisableTime={shouldDisableTime}
          slotProps={{
            textField: {
              helperText: error ? error?.message : helperText,
              error: !!error,
              variant: other.disabled ? 'filled' : 'outlined',
            },
          }}
          {...other}
        />
      )}
    />
  );
}

export default memo(RHFTimePicker);
